import { Controller } from "@hotwired/stimulus";

// Keeps a form's submit button disabled until an autocomplete option is
// picked: typing again drops the pick, choosing an option fills the hidden
// field and enables the button.
export default class extends Controller {
  static targets = ["hidden", "submit"];

  connect() {
    this.update();
  }

  reset() {
    this.hiddenTarget.value = "";
    this.update();
  }

  update() {
    this.submitTarget.disabled = this.hiddenTarget.value === "";
  }
}
